import { lazy } from 'react';

// Compartida con main.jsx (manejo de 'vite:preloadError'): un solo recargo
// automático permitido por pestaña entre ambos mecanismos, para no entrar en
// bucle infinito si el bloqueo persiste tras recargar.
export const LAZY_RETRY_FLAG_KEY = 'signly_lazyRetryReloaded';

// Envuelve React.lazy() para blindarlo contra el caso visto en Sentry
// (issue TypeError: Cannot use 'in' operator to search for 'default' in
// undefined, en /login): el import() dinámico del chunk "se resuelve" con
// undefined en vez de rechazar la promesa -- normalmente por una extensión
// de navegador/antivirus que intercepta la petición del chunk JS y la
// devuelve vacía sin marcarla como error de red. lazyInitializer de React no
// contempla ese caso: revienta con un TypeError nativo y tira toda la
// pantalla al ErrorBoundary. Aquí lo detectamos antes de que React lo vea y,
// la primera vez, recargamos la página para que el usuario se recupere solo
// sin ver la pantalla de error.
export function lazyWithRetry (importFn) {
  return lazy(async () => {
    const moduleObject = await importFn();

    if (!moduleObject || typeof moduleObject.default === 'undefined') {
      const alreadyReloaded = sessionStorage.getItem(LAZY_RETRY_FLAG_KEY) === '1';

      if (!alreadyReloaded) {
        sessionStorage.setItem(LAZY_RETRY_FLAG_KEY, '1');
        window.location.reload();
        // No se resuelve nunca: evita que React siga intentando renderizar
        // con un módulo inválido mientras la recarga surte efecto.
        return new Promise(() => {});
      }

      // Ya recargamos una vez y el módulo sigue llegando vacío: dejamos que
      // el ErrorBoundary existente lo capture y ofrezca su propia
      // recuperación, en vez de recargar en bucle infinito.
      sessionStorage.removeItem(LAZY_RETRY_FLAG_KEY);
      throw new Error('lazyWithRetry: el módulo importado llegó sin export default tras reintentar.');
    }

    // Carga exitosa: si había quedado la bandera de un intento anterior (de
    // esta u otra ruta), se limpia para no arrastrarla a un fallo futuro no
    // relacionado.
    sessionStorage.removeItem(LAZY_RETRY_FLAG_KEY);
    return moduleObject;
  });
}
